export enum Size {
  SMALL = 'small',
  MEDIUM = 'medium',
}

export enum Color {
  COAL = 'coal',
  BLACK = 'black',
  WHITE = 'white',
}
